import { useContext, useState } from "react"
import { useParams, useNavigate } from "react-router-dom";
import ApiContext from "src/provider/API/call-service";
import { AbsoluteContainer, AppSpan, AppText, Button, Circle, CustomContainer, FlexRow } from "src/style"
import { IoIosStar, IoIosStarOutline } from "react-icons/io";
import { BsShare } from "react-icons/bs";
import helpers from "src/utils/helpers";
import { ProductReview, ProductRating, ProductSharing } from "src/popup";
import * as device from 'react-device-detect'
import { Product } from "src/model";
import { comments } from "src/utils/mock-data";

export const ProductInfoTab: React.FC<any> = ({isAdmin, product, isBillingSetup, isPublic}) => {
    const { productId } = useParams()
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const [selectedTab, setSelectedTab] = useState('Description') 
    const [reviews, setReviews] = useState<Array<any>>([])
    const [view, setView] = useState('')
    const billingSetupLabel = 'Monthly Billing Setup'

    function handleTabSelection (tab: string) {
        setSelectedTab(tab)

        if (tab === 'Rating') {
            handleFetchReviews()
        }

        if (isBillingSetup) isBillingSetup(tab === billingSetupLabel)
    }

    async function handleFetchReviews () {
        const payload = {
            pageNumber: 1, 
            pageSize: 3,
            filter: { productId: product.id }
        }
        const response = isPublic ? 
            await API.getPublicProductReviews(payload) 
            : await API.getProductReviews(payload)

        if (response) setReviews(response.data)
    }
    
    return (
        <>
            <CustomContainer>
                <CustomContainer 
                    bottomMargin='2'
                    className='scrollable-container'
                >
                    <FlexRow
                        gap='2' height='4' alignItems='flex-start'
                        className='tab-container'
                    >
                        {
                            tabsInfo.map((item, index) => {
                                return (
                                    (isBillingSetup || (!isBillingSetup && item != billingSetupLabel)) &&
                                        <AppSpan
                                            fontWeight={device.isFirefox ? '400' : '500'}
                                            cursor='pointer'
                                            color={selectedTab === item ? '#0A756F' : '#667085'}
                                            onClick={() => handleTabSelection(item)}
                                            key={index}
                                        >
                                            {item}
                                        </AppSpan>
                                )
                            })
                        }
                        <AbsoluteContainer 
                            bottom='0' 
                            left={selectedTab === 'Description' ? '0' : selectedTab === 'Overview' ? '10' : selectedTab === 'Rating' ? '18.2' : '25'}
                        >
                            <CustomContainer
                                width={selectedTab === 'Description' ? '7.5' : selectedTab === 'Overview' ? '6.7' : selectedTab === 'Rating' ? '5' : '15'}
                                height='0.2' bgColor='#0A756F'
                            />
                        </AbsoluteContainer>
                    </FlexRow>
                </CustomContainer>
                { selectedTab != billingSetupLabel &&
                    <>
                        <CustomContainer 
                            topMargin="2.5" borderColor="#EAECF0"
                            radius="0.8" minHeight="17.2" padding="2" bottomMargin="1"
                            shadow="0px 1px 2px 0px #0000001A, 0px 4px 2px 0px #0000000F"
                        >
                            { selectedTab === 'Description' ?
                                <CustomContainer>
                                    <AppText textSize="1.6">
                                        {product?.description}
                                    </AppText>
                                </CustomContainer>
                                : selectedTab === 'Overview' ?
                                    <>
                                        <FlexRow gap="3" wrap="wrap" alignItems="flex-start">
                                            {
                                                productOverviewInfo(product)?.map((item, index) => {
                                                    return (
                                                        <CustomContainer width="27" key={index}>
                                                            <AppSpan 
                                                                textSize="1.6" color="#333542"
                                                                fontWeight="600"
                                                            >
                                                                {item.key}
                                                            </AppSpan>
                                                            { item.key === 'Ratings' ?
                                                                <FlexRow 
                                                                    gap='2.5'
                                                                >
                                                                    <FlexRow width='auto' sizeUnit='' gap='0.5'>
                                                                        {
                                                                            Array.from(Array(5).keys()).map((num) => {
                                                                                return (
                                                                                    <CustomContainer 
                                                                                        width='auto' sizeUnit=''
                                                                                        key={num}
                                                                                    >
                                                                                        { product.productStatistic?.averageRating >= (num + 1) ?
                                                                                            <IoIosStar fill='#409089' fontSize='1.6rem' />
                                                                                            : <IoIosStarOutline fill='#344054' fontSize='1.6rem' />
                                                                                        }
                                                                                    </CustomContainer>
                                                                                )
                                                                            })
                                                                        }
                                                                    </FlexRow>
                                                                    <AppSpan textSize='1.25'>{Number(item.value)?.toFixed(1)}</AppSpan>
                                                                </FlexRow>
                                                                :
                                                                <AppText color="#333542" fontWeight="300">
                                                                    {item.value}
                                                                </AppText>
                                                            }
                                                        </CustomContainer>
                                                    )
                                                })
                                            }
                                        </FlexRow>
                                    </>
                                    : 
                                    <CustomContainer>
                                        <FlexRow 
                                            justifyContent="space-between" wrap="wrap"
                                            gap="2.5" bottomPadding="1.5"
                                            style={{borderBottom: '1px solid #EAECF0'}}
                                        >
                                            <CustomContainer width="auto" sizeUnit="">
                                                <FlexRow 
                                                    width="auto" sizeUnit="" 
                                                    gap='1'
                                                >
                                                    <AppSpan 
                                                        color="#3A3A3A" fontWeight="600" 
                                                        textSize="3"
                                                    >
                                                        {(product?.productStatistic?.averageRating || 0)?.toFixed(1)}
                                                    </AppSpan>
                                                    <FlexRow width="auto" sizeUnit="" gap="0.7">
                                                        {
                                                            Array.from(Array(5).keys()).map((num) => {
                                                                return (
                                                                    num <= product?.productStatistic?.averageRating - 1 ?
                                                                        <IoIosStar fill='#409089' fontSize='2.5rem' key={num} />
                                                                        : <IoIosStarOutline fill='#344054' fontSize='2.5rem' key={num} />
                                                                )
                                                            })
                                                        }
                                                    </FlexRow>
                                                </FlexRow>
                                                <AppText fontWeight="500" color="#3A3A3A">{product?.productStatistic?.numberOfRatings || 0} ratings</AppText>
                                            </CustomContainer>
                                            { (!isAdmin && !isPublic) &&
                                                <FlexRow 
                                                    width="auto" sizeUnit="" gap="1"
                                                    onClick={() => setView('product-sharing')}
                                                >
                                                    <BsShare fill="#409089" fontSize='1.8rem' />
                                                    <AppSpan 
                                                        color="#409089" textSize='1.8' 
                                                        fontWeight="500" cursor="pointer"
                                                    >
                                                        Share
                                                    </AppSpan>
                                                </FlexRow>
                                            }
                                        </FlexRow>
                                        <FlexRow 
                                            gap="2.5" justifyContent="space-between" wrap="wrap"
                                            topPadding="1.5" bottomPadding="1.5"
                                            style={{borderBottom: '1px solid #EAECF0'}}
                                        >
                                            <AppSpan color="#101828" textSize="1.6" fontWeight="500">Reviews</AppSpan>
                                            { (!isAdmin && !isPublic) &&
                                                <FlexRow width="auto" sizeUnit="" gap="2" wrap="wrap">
                                                    {/* <AppSpan 
                                                        color="#0A756F"
                                                        fontWeight="500" cursor="pointer"
                                                        onClick={() => setView('rating')}
                                                    >
                                                        Rate product
                                                    </AppSpan> */}
                                                    <Button
                                                        width='15.1' color="#0A756F"
                                                        height='4' radius='0.8'
                                                        bgColor="#E7F6F5"
                                                        hoverColor='#0D968F'
                                                        onClick={() => setView('review')}
                                                    >
                                                        Leave a review
                                                    </Button>
                                                </FlexRow>
                                            }
                                        </FlexRow>
                                        <CustomContainer>
                                            {
                                                reviews?.map((item, index) => {
                                                    const [firstName, lastName] = item.ratedBy?.split(' ')
                                                    return (
                                                        <CustomContainer key={index} topMargin="1.5">
                                                            <FlexRow gap="1">
                                                                <Circle size="4" bgColor='#494949'>
                                                                    <AppSpan color="#F7F8F9" fontWeight="600">{firstName[0]}{lastName[0]}</AppSpan>
                                                                </Circle>
                                                                <AppSpan color="#3A3A3A" fontWeight="500">{item.ratedBy}</AppSpan>
                                                            </FlexRow>
                                                            <FlexRow gap="1" topMargin="1" wrap="wrap">
                                                                <FlexRow width="auto" sizeUnit="" gap="0.5">
                                                                    {
                                                                        Array.from(Array(5).keys())?.map((num: number) => {
                                                                            return (
                                                                                num <= (item?.rating - 1) ?
                                                                                    <IoIosStar fill='#409089' fontSize='1.4rem' key={num} />
                                                                                    : <IoIosStarOutline fill='#344054' fontSize='1.4rem' key={num} />
                                                                            )
                                                                        })
                                                                    }
                                                                </FlexRow>
                                                                <AppSpan color="#3A3A3A" textSize="1.2">
                                                                    {item.dateCreated ? helpers.handleDate(item.dateCreated) : null}
                                                                </AppSpan>
                                                            </FlexRow>
                                                            <AppText topMargin="1">{item.comment?.comment}</AppText>
                                                        </CustomContainer>
                                                    )
                                                })
                                            }
                                        </CustomContainer>
                                        { reviews?.length > 2 &&
                                            <CustomContainer topMargin="1.5">
                                                <AppSpan 
                                                    color="#0A756F" cursor="pointer" 
                                                    hoverColor="#3A3A3A" fontWeight="500"
                                                    onClick={() => navigate(`/general/product/${productId}/comments`)}
                                                >
                                                    See more
                                                </AppSpan>
                                            </CustomContainer>
                                        }
                                    </CustomContainer>
                            }
                        </CustomContainer>
                        { selectedTab === 'Overview' &&
                            <CustomContainer 
                                topMargin="1.5" borderColor="#EAECF0" bottomMargin="1"
                                radius="0.8" minHeight="17.2" padding="2"
                                shadow="0px 1px 2px 0px #0000001A, 0px 4px 2px 0px #0000000F"
                            >
                                <CustomContainer>
                                    <AppSpan 
                                        textSize="1.6" color="#333542"
                                        fontWeight="600"
                                    >
                                        Product features
                                    </AppSpan>
                                    <AppText color="#333542" fontWeight="300">
                                        {product.features}
                                    </AppText>
                                </CustomContainer>
                            </CustomContainer>
                        }
                    </>
                }
            </CustomContainer>
            { view === 'review' &&
                <ProductReview 
                    product={product}
                    fetchReviews={handleFetchReviews}
                    close={() => setView('')}
                />
            }
            {/* { view === 'rating' &&
                <ProductRating 
                    close={() => setView('')}
                />
            } */}
            { view === 'product-sharing' &&
                <ProductSharing 
                    productId={productId}
                    close={() => setView('')}
                />
            }
        </>
    )
}

const tabsInfo = ['Description' ,'Overview', 'Rating', 'Monthly Billing Setup']

const productOverviewInfo = (product: Product) => [
    {
        key: 'Product category',
        value: product?.serviceCategory?.name
    },
    {
        key: 'Usage guide url',
        value: product.usageGuide
    },
    {
        key: 'Product owner',
        value: product?.serviceProvider?.companyName
    },
    {
        key: 'Product website url',
        value: product?.serviceProvider?.websiteURL
    },
    {
        key: 'Recurring monthly fee',
        value: 'N2000'
    },
    {
        key: 'Activated banks',
        value: product?.productStatistic?.installation
    },
    {
        key: 'Ratings',
        value: product?.productStatistic?.averageRating || 0
    },
    // {
    //     key: 'No. of FI’s',
    //     value: '3'
    // }
]
